import { useEffect } from "react";
import { loadTrackingConfig } from "@/lib/analytics";

/**
 * Injects GA4, Google Ads and Meta Pixel tags when IDs are configured
 * (set by the owner in /admin → Tracking). No IDs configured = no tags loaded.
 */
export default function Analytics() {
  useEffect(() => {
    loadTrackingConfig().then((cfg) => {
      if (!cfg) return;

      if (cfg.gsc_verify) {
        const meta = document.createElement("meta");
        meta.name = "google-site-verification";
        meta.content = cfg.gsc_verify;
        document.head.appendChild(meta);
      }

      if (cfg.ga4_id) {
        const s = document.createElement("script");
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(cfg.ga4_id)}`;
        document.head.appendChild(s);
        window.dataLayer = window.dataLayer || [];
        window.gtag = function gtag() { window.dataLayer.push(arguments); };
        window.gtag("js", new Date());
        window.gtag("config", cfg.ga4_id);
        if (cfg.google_ads_id) {
          window.gtag("config", cfg.google_ads_id);
        }
      }

      if (cfg.meta_pixel_id) {
        /* eslint-disable */
        !(function (f, b, e, v, n, t, s) {
          if (f.fbq) return; n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0";
          n.queue = []; t = b.createElement(e); t.async = !0;
          t.src = v; s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
        /* eslint-enable */
        window.fbq("init", cfg.meta_pixel_id);
        window.fbq("track", "PageView");
      }
    });
  }, []);

  return null;
}
